import { configureStore } from '@reduxjs/toolkit'
import quoteItemsReducer from './features/counter/quoteItemsSlice'

export default configureStore({
  reducer: {
    quoteItems: quoteItemsReducer
  },
});